import React from "react";
import { Box, Typography, Avatar, Grid, ListItem, List, Tooltip, capitalize } from "@mui/material";
import RectangleIcon from "@mui/icons-material/Rectangle";
import moment from "moment";
import { useNavigate } from "react-router-dom";

interface DataPipelineRequestsTableProps {
    dataPipelines: any[];
    resourceStatuses: any[];
}

const DataPipelineRequestsTable: React.FC<DataPipelineRequestsTableProps> = ({
    dataPipelines, 
    resourceStatuses
}: DataPipelineRequestsTableProps) => {
    const [cardHoverIndex, setCardHoverIndex] = React.useState<number | null>(null);
    const navigate = useNavigate();
        
    return (
        <List sx={{ bgcolor: "#fafafa" }}>
            <ListItem sx={{ bgcolor: "#f2f2f2", borderRadius: "4px" }}>
                <Box width="100%">
                    <Grid container direction="row" alignItems="center">
                        <Grid item xs={2}><Typography fontSize="12px">PIPELINE NAME</Typography></Grid>
                        <Grid item xs={1.5}><Typography fontSize="12px">APPLICATION</Typography></Grid>
                        <Grid item xs={1.5}><Typography fontSize="12px">CATEGORY TYPE</Typography></Grid>
                        <Grid item xs={1.5}><Typography fontSize="12px">CLOUD IDENTIFIER</Typography></Grid>
                        <Grid item textAlign="start" xs={1.5}><Typography fontSize="12px">OWNER</Typography></Grid>
                        <Grid item textAlign="start" xs={1.5}><Typography fontSize="12px">REQUESTED ON</Typography></Grid>
                        <Grid textAlign="start" item xs={1.5}><Typography fontSize="12px">ACTIONED BY/ REASON</Typography></Grid>
                        <Grid item textAlign="start" xs={1}><Typography fontSize="12px">ACTIONED ON</Typography></Grid>
                    </Grid>
                </Box>
            </ListItem>
            {dataPipelines.map((pipeline: any, index: number) => (
                <ListItem
                    key={pipeline.id}
                    sx={{
                        border: cardHoverIndex === index ? "1px solid #000" : "1px solid #00000000",
                        mt: 1,
                        cursor: "pointer",
                        bgcolor: pipeline.status === "active" || pipeline.status === "approved" ? "#FFFFFF" : pipeline.status === "rejected" ? "#F0443810" : "#FDB02210",
                        borderRadius: "8px",
                    }}
                    onClick={() => {
                        navigate(`/datasolutions/requests/data-pipelines/${pipeline.id}`); 
                    }}
                    onMouseEnter={() => setCardHoverIndex(index)}
                    onMouseLeave={() => { setCardHoverIndex(null); }}
                >
                    <Box width="100%" sx={{}}>
                        <Grid container direction="row" alignItems="center" justifyContent="space-between">
                            <Grid item xs={2}>
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <RectangleIcon sx={{ color: pipeline.status === "active" || pipeline.status === "approved" ? "#12B76A" : pipeline.status === "rejected" ? "#F04438" : "#FDB022", bgcolor: pipeline.status === "active" || pipeline.status === "approved" ? "#12B76A" : pipeline.status === "rejected" ? "#F04438" : "#FDB022", width: "4px", marginRight: "8px" }} />
                                    <Typography fontSize="14px" fontFamily="Gilroy-Medium">{pipeline.pipelineName}</Typography>
                                    {(pipeline.status === 'active' || pipeline.status === 'approved') && resourceStatuses && resourceStatuses.length > 0 ? ( 
                                        <Tooltip sx={{ whiteSpace: "pre-line" }} title={ <Box key={`${pipeline.id}-tooltip`}>Current Status<br />{resourceStatuses.filter((e:any) => e.resourceId === pipeline.id).map((e: any, i: number) => ( <React.Fragment key={`${pipeline.id}-status-${i}`}>{capitalize(e.currentStatus)}<br /></React.Fragment> ))}</Box> }>
                                            <Avatar src="/assets/info.svg" alt="info" sx={{ height: 16, width: 16, marginLeft: "4px" }} />
                                        </Tooltip>
                                    ) : null}
                                </Box>
                            </Grid>
                            <Grid item xs={1.5}><Typography fontSize="14px" fontFamily="Gilroy-Regular">{pipeline.applicationName || 'N/A'}</Typography></Grid>
                            <Grid item xs={1.5}><Typography fontSize="14px" fontFamily="Gilroy-Regular">{pipeline.solutionCategoryType || 'N/A'}</Typography></Grid>
                            <Grid item xs={1.5}><Typography fontSize="14px" fontFamily="Gilroy-Regular" sx={{ textTransform: 'uppercase' }}>{pipeline.cloudProvider || 'N/A'}</Typography></Grid>
                            <Grid item xs={1.5}>
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <Avatar src={pipeline.pipelineOwnerAvatar} alt={pipeline.pipelineOwnerName} sx={{ marginRight: "8px", height: 30, width: 30 }}>{pipeline.pipelineOwnerName ? pipeline.pipelineOwnerName.charAt(0).toUpperCase() : ''}</Avatar>
                                    <Typography fontSize="14px" fontFamily="Gilroy-Regular">{pipeline.pipelineOwnerName}</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={1.5}>
                                <Box display="flex" alignItems="center"><Typography fontSize="14px" fontFamily="Gilroy-Regular">{pipeline.createdAt ? moment(pipeline.createdAt).format("DD/MM/YYYY | hh:mm A") : 'N/A'}</Typography></Box>
                            </Grid>
                            <Grid item xs={1.5}>
                                {pipeline.status !== "pending" && (
                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                        {pipeline.pipelineApproverName &&
                                            <Avatar src={pipeline.pipelineApproverAvatar} alt={pipeline.pipelineApproverName} sx={{ marginRight: "8px", height: 30, width: 30 }}>{pipeline.pipelineApproverName.charAt(0).toUpperCase()}</Avatar>
                                        }
                                        {pipeline.pipelineApproverName &&
                                            <Typography fontSize="14px" fontFamily="Gilroy-Regular" mr={1}>{pipeline.pipelineApproverName}</Typography>
                                        }
                                        {pipeline.status === "rejected" && pipeline.reasonForRejection && (
                                            <Tooltip title={`Reason: ${pipeline.reasonForRejection}`}><img src="/assets/info.svg" alt="info" /></Tooltip>
                                        )}
                                    </Box>
                                )}
                            </Grid>
                            <Grid item xs={1}>
                                {(pipeline.status !== "pending" && pipeline.actionedAt) && (
                                    <Box display="flex" alignItems="center"><Typography fontSize="14px" fontFamily="Gilroy-Regular">{moment(pipeline.actionedAt).format("DD/MM/YYYY | hh:mm A")}</Typography></Box>
                                )}
                            </Grid>
                        </Grid>
                    </Box>
                </ListItem>
            ))}
        </List>
    );
};

export default DataPipelineRequestsTable;